var map = {
	"./add-icon.svg": "g+dX",
	"./audit-log-black.svg": "rEBx",
	"./audit-log.svg": "/Vtg",
	"./bell-module.svg": "uYP9",
	"./bell-regular.svg": "Nxp1",
	"./brochure.svg": "C67+",
	"./calendar-green.svg": "xTHz",
	"./calendar.svg": "ONfI",
	"./campaign.svg": "mbI+",
	"./chat-bubbles-master-read.svg": "mGgd",
	"./chat-bubbles-master-unread.svg": "8opw",
	"./chat-bubbles-none.svg": "ZIUj",
	"./chat-bubbles-read.svg": "EEuQ",
	"./chat-bubbles-unread.svg": "aI+E",
	"./chat-bubbles.svg": "kcYL",
	"./chevron-down.svg": "/J+S",
	"./chevron-up.svg": "oimD",
	"./collapse.svg": "Ecm0",
	"./communication-action-plan.svg": "VjEZ",
	"./datepicker-next.png": "jh+x",
	"./datepicker-prev.png": "y4iK",
	"./design.svg": "BytH",
	"./dropdown-arrow.svg": "w8cW",
	"./dummy-chat.svg": "AOYw",
	"./event.svg": "yQ7B",
	"./expand-menu.svg": "d0ko",
	"./expand.svg": "NsYk",
	"./external-link-alt-solid.svg": "3WVn",
	"./filter.svg": "M6qk",
	"./green-folder.svg": "Cfzz",
	"./green-plus.svg": "odgp",
	"./home.svg": "Vj4Z",
	"./link-dropbox.svg": "QwOD",
	"./link-file.svg": "uIQA",
	"./link-google-drive.svg": "gmc3",
	"./link-onedrive.svg": "y5/E",
	"./link-teams.svg": "sE7m",
	"./link-url.svg": "IGuV",
	"./link-web.svg": "j1yQ",
	"./logo.svg": "cxMh",
	"./logout.svg": "tsMd",
	"./magazine.svg": "kaDY",
	"./marketing-project.svg": "J9A2",
	"./media-call-nav.svg": "m9dw",
	"./media-call.svg": "9Coh",
	"./media-event.svg": "Xwhu",
	"./my-week-list.svg": "kWF2",
	"./my-week.svg": "ay0R",
	"./news-release.svg": "xYmo",
	"./organic-social-media.svg": "es34",
	"./pencil.svg": "m+9I",
	"./plus.svg": "MUPt",
	"./popup-add.svg": "Tsxk",
	"./popup-minus.png": "mICD",
	"./poster.svg": "a4Yz",
	"./print-ad.svg": "NSlO",
	"./project-deliverable.svg": "mbUz",
	"./projects-black.svg": "iN2E",
	"./projects.svg": "0Icl",
	"./report-icon.svg": "2kDr",
	"./report.svg": "RcES",
	"./search.svg": "vfQ8",
	"./select-arrow.png": "q9iD",
	"./sm-calendar-placeholder.svg": "18xa",
	"./social-media-post.svg": "tKpR",
	"./social-media-white.svg": "ybr8",
	"./social-media.svg": "rJVF",
	"./twitter-reply.svg": "KkqT",
	"./twitter-retweet.svg": "k4Bl",
	"./twitter.svg": "1e17",
	"./undo.svg": "zzmp",
	"./up-down.svg": "hsSO",
	"./web-project.svg": "Kra3",
	"./website.svg": "DRUg",
	"./white-folder.svg": "0h4S",
	"./writing-assignment.svg": "be29",
	"./year-calendar-tooltip.svg": "1WBH"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "X1N+";